export class FormErrors {
    constructor(form = null) {
        if (!form) return;
        this.root = form;
    }

    clearErrors(fieldsToCheck = null, withTextClear = false) {
        const fields =
            fieldsToCheck ??
            this.root.querySelectorAll(
                'input:not([type="hidden"])',
                'textarea',
                'select'
            );

        fields.forEach(field => {
            const parent = field.closest('.group');
            parent.classList.remove('-error');
            const errorText = parent.querySelector('[js-error-text]');
            if (withTextClear) {
                errorText.textContent = '';
            }
        });
    }

    handleFieldError(element = null, isError = true, message = '') {
        if (!element) return;

        if (typeof element === 'string') {
            element = this.root.querySelector(`[name="${element}"]`);
        }

        const parent = element.closest('.group');
        parent.classList.remove('-error');
        const errorText = parent.querySelector('[js-error-text]');

        if (isError) {
            errorText.textContent = '';
            parent.classList.add('-error');
            errorText.textContent = message;
        } else {
            setTimeout(() => {
                errorText.textContent = '';
            }, 500);
        }
    }
}
